import type { ReactNode } from 'react';
import { MessageCircle, ListTodo, History, MessagesSquare } from 'lucide-react';
import { CrmDealAccordion } from './CrmDealAccordion';

type Props = {
  stageBlock: ReactNode;
  leadContextBlock?: ReactNode;
  handoffHint?: ReactNode;
  taskListBlock: ReactNode;
  activityFeed: ReactNode;
  activityHighlight?: boolean;
  chatAndManagerBlock?: ReactNode;
  taskGateHighlight?: boolean;
};

/** Вложенные секции внутри макро «Продажи и коммуникация». */
export function CrmDealSalesBody({
  stageBlock,
  leadContextBlock,
  handoffHint,
  taskListBlock,
  activityFeed,
  activityHighlight = false,
  chatAndManagerBlock,
  taskGateHighlight = false,
}: Props) {
  return (
    <div className="space-y-2">
      {leadContextBlock}
      <CrmDealAccordion
        title="Этап воронки"
        subtitle="Маршрут сделки и статус"
        accent="#63B3ED"
        icon={<MessageCircle size={15} color="#63B3ED" />}
        defaultOpen={false}
      >
        <div className="space-y-3">
          {stageBlock}
          {handoffHint}
        </div>
      </CrmDealAccordion>
      <CrmDealAccordion
        title="Задачи"
        subtitle="Звонки и follow-up"
        accent="#F6AD55"
        icon={<ListTodo size={15} color="#F6AD55" />}
        highlight={taskGateHighlight}
        defaultOpen={taskGateHighlight}
      >
        {taskListBlock}
      </CrmDealAccordion>
      <CrmDealAccordion
        title="История и звонок"
        subtitle="Лента активности"
        accent="#FC814A"
        icon={<History size={15} color="#FC814A" />}
        defaultOpen={activityHighlight}
        highlight={activityHighlight}
      >
        <div
          id="crm-deal-activity-feed"
          className="rounded-xl transition-shadow duration-300"
          style={
            activityHighlight
              ? {
                  boxShadow: '0 0 0 2px var(--orange, #FC814A)',
                  background: 'color-mix(in srgb, var(--orange, #FC814A) 8%, transparent)',
                }
              : undefined
          }
        >
          {activityFeed}
        </div>
      </CrmDealAccordion>
      {chatAndManagerBlock && (
        <CrmDealAccordion
          title="Чат и менеджер"
          subtitle="Telegram, назначение"
          accent="#D6BCFA"
          icon={<MessagesSquare size={15} color="#D6BCFA" />}
          defaultOpen={false}
        >
          <div className="space-y-3">{chatAndManagerBlock}</div>
        </CrmDealAccordion>
      )}
    </div>
  );
}
